import session from "redux-persist/lib/storage/session";
import axios, { account, partnerServices } from "../../config/axios";
import {
  LOGIN_SUCCESS,
  LOGIN_INCORRECT_USERNAME_PASSWORD,
  LOGIN_FAILED,
  LOGIN_NOT_AVAILABLE,
  LOGIN_DEALER_MISSING,
  LOGIN_APPROVAL_PENDING,
  LOGIN_KYC_PENDING,
  LOGIN_KYB_PENDING,
  LOADING_LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_FAILED,
  NETWORK_ERROR_LOGOUT,
  SIGNUP_FAILED,
  SIGNUP_INVALID_OTP,
  SIGNUP_INVALID_DOB,
  SIGNUP_INVALID_EMAIL,
  SIGNUP_INVALID_TELNOCC,
  SIGNUP_INVALID_MOBILENUMBER,
  SIGNUP_INVALID_PASSWORD,
  SIGNUP_INVALID_FIRSTNAME,
  SIGNUP_INVALID_LASTNAME,
  SIGNUP_INVALID_COUNTRY,
  SIGNUP_INVALID_ACNTTYPE,
  SIGNUP_INVALID_WALLETOWNNERID,
  SIGNUP_INVALID_PLATFORMID,
  SIGNUP_INVALID_CURRENCY,
  SIGNUP_INVALID_MOBILEOTP,
  SIGNUP_INVALID_EMAILOTP,
  SIGNUP_INVALID_TERMSCONSENT,
  SIGNUP_INVALID_COUNTRYCODE,
  SIGNUP_INVALID_ADDRDETAILS,
  SIGNUP_INVALID_THANA,
  SIGNUP_INVALID_UNION,
  SIGNUP_SUCCESS,
  LOADING_LOGIN,
  LOADING_SIGNUP,
  ACCOUNT_LOCKED,
  NETWORK_ERROR_LOGIN,
  NETWORK_ERROR_SIGNUP,
  INSERT_OTP_SUCCESS,
  INSERT_OTP_FAILED,
  INSERT_OTP_ALREADY_REGISTERED,
  INSERT_OTP_INVALID_PASSWORD,
  LOADING_INSERT_OTP,
  RESET_INSERT_OTP,
  RESET_SIGNUP,
  RESET_APP,
  RESET_LOGIN,
  WALLET_SETTING_SUCCESS,
  WALLET_SETTING_FAILED,
  WALLET_SETTING_INVALID_REQ,
  LOADING_WALLET_SETTING,
  RESET_WALLET_SETTING,
  WALLET_ROLES_SUCCESS,
  WALLET_ROLES_FAILED,
  WALLET_ROLES_INVALID_WALLET_ID,
  WALLET_ROLES_INVALID_TOKEN,
  RESET_WALLET_ROLES,
  LOADING_WALLET_ROLES,
  GET_DDT_FAILED,
  // GET_DDT_INVALID_TOKEN,
  GET_DDT_INVALID_REQ,
  LOADING_GET_DDT,
  RESET_GET_DDT,
  GET_DDT_SUCCESS,
  GET_BANKLIST_FAILED,
  GET_BANKLIST_INVALID_REQ,
  GET_BANKLIST_SUCCESS,
  LOADING_GET_BANKLIST,
  RESET_GET_BANKLIST,
  GET_BRANCHLIST_FAILED,
  GET_BRANCHLIST_INVALID_REQ,
  GET_BRANCHLIST_SUCCESS,
  LOADING_GET_BRANCHLIST,
  RESET_GET_BRANCHLIST,
  GET_POSTALCODES_FAILED,
  GET_POSTALCODES_INVALID_REQ,
  GET_POSTALCODES_SUCCESS,
  LOADING_GET_POSTALCODES,
  RESET_GET_POSTALCODES,
  LOGOUT_INVALID_REQUEST,
  RESET_LOGOUT,
} from "../types";

const loginUser = (userData, history) => async (dispatch) => {
  dispatch(loadingLogin());
  dispatch(resetSignup());

  await partnerServices
    .post("partnerLogin", userData)
    .then((res) => {
      switch (res.data.status) {

        case "success":
          sessionStorage.setItem("authToken",res.data.AuthToken)
          localStorage.setItem("walletOwnerId",res.data.partnerId);
          // Pass the  data after success
          dispatch(success(res.data));
          //history.push({ pathname: "/index/dashboard" });
          history.push({ pathname: "/index/homepage" });
          break;

        case "Wrong Password":
          dispatch(wrongUsernamePassword(res.data));
          break;

        case "NOT_AVAILABLE":
          dispatch(notAvailable(res.data));
          break;

        case "Account Locked":
          dispatch(accountLocked(res.data));
          break;

        case "Failed":
          dispatch(failed(res.data));
          break;

        case "failed":
          dispatch(failed(res.data));
          break;

        case "Approval Pending":
          dispatch(approvalPending(res.data));
          break;

        case "KYC Pending":
          dispatch(kycPending(res.data));
          break;

        case "KYB Pending":
          dispatch(kybPending(res.data));
          break;

        case "Dealer Missing":
          dispatch(dealerMissing(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) => dispatch({ type: NETWORK_ERROR_LOGIN, payload: err }));
};

function accountLocked(data) {
  return {
    type: ACCOUNT_LOCKED,
    payload: data,
  };
}

function loadingLogin() {
  return {
    type: LOADING_LOGIN,
  };
}

function wrongUsernamePassword(data) {
  return {
    type: LOGIN_INCORRECT_USERNAME_PASSWORD,
    payload: data,
  };
}

function notAvailable(data) {
  return {
    type: LOGIN_NOT_AVAILABLE,
    payload: data,
  };
}

function success(data) {
  return {
    type: LOGIN_SUCCESS,
    payload: data,
  };
}

function failed(data) {
  return {
    type: LOGIN_FAILED,
    payload: data,
  };
}

function approvalPending(data) {
  return {
    type: LOGIN_APPROVAL_PENDING,
    payload: data,
  };
}

function kycPending(data) {
  return {
    type: LOGIN_KYC_PENDING,
    payload: data,
  };
}

function kybPending(data) {
  return {
    type: LOGIN_KYB_PENDING,
    payload: data,
  };
}

function dealerMissing(data) {
  return {
    type: LOGIN_DEALER_MISSING,
    payload: data,
  };
}

const getWalletRoles = (userData) => async (dispatch) => {
  // if (!getState().getWalletRoles.success) {
  dispatch(loadingWalletRoles());
  await account
    .post("getAllWalletRoles", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(gWRSuccess(res.data));
          break;

        case "38":
          dispatch(gWRInvalidWalletId(res.data));
          break;

        case "17":
          dispatch(gWRInvalidToken(res.data));
          break;

        case "2":
          dispatch(gWRFail(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) => err);
  // }
};

function loadingWalletRoles() {
  return {
    type: LOADING_WALLET_ROLES,
  };
}

function gWRSuccess(data) {
  return {
    type: WALLET_ROLES_SUCCESS,
    payload: data,
  };
}

function gWRFail(data) {
  return {
    type: WALLET_ROLES_FAILED,
    payload: data,
  };
}

function gWRInvalidToken(data) {
  return {
    type: WALLET_ROLES_INVALID_TOKEN,
    payload: data,
  };
}

function gWRInvalidWalletId(data) {
  return {
    type: WALLET_ROLES_INVALID_WALLET_ID,
    payload: data,
  };
}

function resetWalletRoles() {
  return {
    type: RESET_WALLET_ROLES,
  };
}

const signupUser =
  (userData, history, isDefault, customerOption) => async (dispatch) => {
    dispatch(loadingSignup());
    dispatch(resetLogin());

    // let Axios = account;
    // if (!isDefault) Axios = axios;

    await account
      .post(
        `${isDefault ? "customerRegistration" : "createBusinessAccount"}`,
        userData
      )
      .then((res) => {
        const status = res.data.registerStatus;
        switch (status) {
          case "SUCCESS":
            dispatch(signupSuccess(res.data));
            if (!customerOption) {
              history.push({
                pathname: "/index/login",
              });
            }

            break;

          case "INVALID_OTP":
            dispatch(signupInvalidOtp());
            break;

          case "Invalid Date of birth":
            dispatch(signupInvalidDob(status));
            break;

          case "Invalid Email":
            dispatch(signupInvalidEmail(status));
            break;

          case "Invalid Telno CC":
            dispatch(signupInvalidTelNoCC(status));
            break;

          case "Invalid Mobile Number":
            dispatch(signupInvalidMobileNumber(status));
            break;

          case "Invalid Password":
            dispatch(signupInvalidPassword(status));
            break;

          case "Invalid First Name":
            dispatch(signupInvalidFirstName(status));
            break;

          case "Invalid Last Name":
            dispatch(signupInvalidLastName(status));
            break;

          case "Invalid Country":
            dispatch(signupInvalidCountry(status));
            break;

          case "Invalid Account Type":
            dispatch(signupInvalidAcntType(status));
            break;

          case "Invalid Wallet Owner Id":
            dispatch(signupInvalidWalletOwnerId(status));
            break;

          case "Invalid Platform Id":
            dispatch(signupInvalidPlatformId(status));
            break;

          case "Invalid Currency":
            dispatch(signupInvalidCurrency(status));
            break;

          case "Invalid Mobile OTP":
            dispatch(signupInvalidMobileOTP(status));
            break;

          case "Invalid Email OTP":
            dispatch(signupInvalidEmailOTP(status));
            break;

          case "Invalid Terms Consent":
            dispatch(signupInvalidTermsConsent(status));
            break;

          case "Invalid Country Code":
            dispatch(signupInvalidCountryCode(status));
            break;

          case "Invalid, Please provide the address details.":
            dispatch(signupInvalidAddressDetails(status));
            break;

          case "Invalid Thana":
            dispatch(signupInvalidThana(status));
            break;

          case "Invalid Union":
            dispatch(signupInvalidUnion(status));
            break;

          case "FAILED":
            dispatch(signupFailed(res.data));
            break;

          default:
            dispatch(signupFailed(res.data));
            break;
        }
      })
      .catch((err) => dispatch({ type: NETWORK_ERROR_SIGNUP, payload: err }));
  };

function transformPayload(data) {
  return data.replace(/.{2}/, "Please enter ");
}

function loadingSignup() {
  return {
    type: LOADING_SIGNUP,
  };
}

function signupSuccess(data) {
  return {
    type: SIGNUP_SUCCESS,
    payload: data,
  };
}

function signupInvalidAddressDetails(data) {
  return {
    type: SIGNUP_INVALID_ADDRDETAILS,
    payload: data,
  };
}

function signupInvalidThana(data) {
  return {
    type: SIGNUP_INVALID_THANA,
    payload: data,
  };
}

function signupInvalidUnion(data) {
  return {
    type: SIGNUP_INVALID_UNION,
    payload: data,
  };
}

function signupInvalidDob(data) {
  return {
    type: SIGNUP_INVALID_DOB,
    payload: transformPayload(data),
  };
}

function signupInvalidEmail(data) {
  return {
    type: SIGNUP_INVALID_EMAIL,
    payload: transformPayload(data),
  };
}

function signupInvalidTelNoCC(data) {
  return {
    type: SIGNUP_INVALID_TELNOCC,
    payload: transformPayload(data),
  };
}

function signupInvalidMobileNumber(data) {
  return {
    type: SIGNUP_INVALID_MOBILENUMBER,
    payload: transformPayload(data),
  };
}

function signupInvalidPassword(data) {
  return {
    type: SIGNUP_INVALID_PASSWORD,
    payload: transformPayload(data),
  };
}

function signupInvalidFirstName(data) {
  return {
    type: SIGNUP_INVALID_FIRSTNAME,
    payload: transformPayload(data),
  };
}

function signupInvalidLastName(data) {
  return {
    type: SIGNUP_INVALID_LASTNAME,
    payload: transformPayload(data),
  };
}

function signupInvalidCountry(data) {
  return {
    type: SIGNUP_INVALID_COUNTRY,
    payload: transformPayload(data),
  };
}

function signupInvalidAcntType(data) {
  return {
    type: SIGNUP_INVALID_ACNTTYPE,
    payload: transformPayload(data),
  };
}

function signupInvalidWalletOwnerId(data) {
  return {
    type: SIGNUP_INVALID_WALLETOWNNERID,
    payload: transformPayload(data),
  };
}

function signupInvalidPlatformId(data) {
  return {
    type: SIGNUP_INVALID_PLATFORMID,
    payload: transformPayload(data),
  };
}

function signupInvalidCurrency(data) {
  return {
    type: SIGNUP_INVALID_CURRENCY,
    payload: transformPayload(data),
  };
}

function signupInvalidMobileOTP(data) {
  return {
    type: SIGNUP_INVALID_MOBILEOTP,
    payload: transformPayload(data),
  };
}

function signupInvalidEmailOTP(data) {
  return {
    type: SIGNUP_INVALID_EMAILOTP,
    payload: transformPayload(data),
  };
}

function signupInvalidTermsConsent(data) {
  return {
    type: SIGNUP_INVALID_TERMSCONSENT,
    payload: transformPayload(data),
  };
}

function signupInvalidCountryCode(data) {
  return {
    type: SIGNUP_INVALID_COUNTRYCODE,
    payload: transformPayload(data),
  };
}

function signupInvalidOtp() {
  return {
    type: SIGNUP_INVALID_OTP,
  };
}

function signupFailed() {
  return {
    type: SIGNUP_FAILED,
  };
}

const insertOtp = (userData) => async (dispatch) => {
  dispatch({ type: LOADING_INSERT_OTP });

  await account
    .post("getOtp", userData)
    .then((res) => {
      switch (res.data.status) {
        case "SUCCESS":
          dispatch({ type: INSERT_OTP_SUCCESS, payload: res.data.status });
          break;

        case "FAILED":
          dispatch({ type: INSERT_OTP_FAILED, payload: res.data.status });
          break;

        case "Invalid Password":
          dispatch({
            type: INSERT_OTP_INVALID_PASSWORD,
            payload:
              "Invalid Password. Password must contain at least one digit,one lower case,one upper case,special characters[@#$%^*!] and minimum length 8",
          });
          break;

        case "Already Registered":
          dispatch({
            type: INSERT_OTP_ALREADY_REGISTERED,
            payload: res.data.status,
          });
          break;

        default:
          break;
      }
    })
    .catch((err) => dispatch({ type: NETWORK_ERROR_SIGNUP, payload: err }));
};

const logoutUser = (userData, history) => async (dispatch) => {
  dispatch({ type: LOADING_LOGOUT });

  // console.log(userData);
  userData.authToken = sessionStorage.getItem("authToken") || "";

  await partnerServices
    .post("logout", userData)
    .then((res) => {
      switch (res.data.status.toUpperCase()) {
        case "SUCCESS":
          dispatch(logoutSuccess(res.data));
          sessionStorage.removeItem("authToken");
          sessionStorage.removeItem("walletOwnerId");
          if (userData.authentication.partnerId == 2) {
            history.push({
              pathname: "/index/adminLogin",
            });
          }
          break;

        case "FAILED":
          case "failed":
          dispatch(logoutFailed(res.data));

                    // history.push({ pathname: "/index/login" });
          // history.push({ pathname: "/index/login" });
          break;

        

        case "INVALID_REQUEST":
          dispatch(logoutInvalidRequest(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) => dispatch({ type: NETWORK_ERROR_LOGOUT, payload: err }));
};

const logoutSuccess = (data) => {
  return {
    type: LOGOUT_SUCCESS,
    payload: data,
  };
};

const logoutFailed = (data) => {
  return {
    type: LOGOUT_FAILED,
    payload: data,
  };
};

const logoutInvalidRequest = (data) => {
  return {
    type: LOGOUT_INVALID_REQUEST,
    payload: data,
  };
};

const resetLogout = () => {
  return {
    type: RESET_LOGOUT,
  };
};

const resetApp = () => {
  return {
    type: RESET_APP,
  };
};

const resetLogin = () => {
  return {
    type: RESET_LOGIN,
  };
};

const resetInsertOTP = () => {
  return {
    type: RESET_INSERT_OTP,
  };
};

const resetSignup = () => {
  return {
    type: RESET_SIGNUP,
  };
};

const getWalletSettings = (userData) => async (dispatch) => {
  dispatch(loadWalletSetting());

  await account
    .post("walletSetting", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(walletSettingsSuccess(res.data));
          break;

        case "2":
          dispatch(walletSettingsFailed(res.data));
          break;

        case "3":
          dispatch(walletSettingsInvalidReq(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) => err);
};

function loadWalletSetting() {
  return {
    type: LOADING_WALLET_SETTING,
  };
}

function walletSettingsSuccess(data) {
  return {
    type: WALLET_SETTING_SUCCESS,
    payload: data,
  };
}

function walletSettingsFailed(data) {
  return {
    type: WALLET_SETTING_FAILED,
    payload: data,
  };
}

function walletSettingsInvalidReq(data) {
  return {
    type: WALLET_SETTING_INVALID_REQ,
    payload: data,
  };
}

function resetWalletSetting() {
  return {
    type: RESET_WALLET_SETTING,
  };
}

const getDDT = (userData) => async (dispatch) => {
  dispatch(loadDDT());

  return await account.post("getAllDivisionsDistrictThana", userData);
};

const gaddtResponse = (data) => (dispatch) => {
  switch (data.responseCode) {
    case "1":
      dispatch(ddtSuccess(data));
      break;

    case "2":
      dispatch(ddtFailed(data));
      break;

    case "3":
      dispatch(ddtInvalidReq(data));
      break;

    default:
      dispatch(ddtFailed(data));
      break;
  }
};

function loadDDT() {
  return {
    type: LOADING_GET_DDT,
  };
}

function ddtSuccess(data) {
  return {
    type: GET_DDT_SUCCESS,
    payload: data,
  };
}

function ddtFailed(data) {
  return {
    type: GET_DDT_FAILED,
    payload: data,
  };
}

function ddtInvalidReq(data) {
  return {
    type: GET_DDT_INVALID_REQ,
    payload: data,
  };
}

function resetDDT() {
  return {
    type: RESET_GET_DDT,
  };
}

const getBankList = (userData) => async (dispatch) => {
  dispatch(loadBankList());

  await account
    .post("getBankList", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(bankListSuccess(res.data));
          break;

        case "2":
          dispatch(bankListFailed(res.data));
          break;

        case "3":
          dispatch(bankListInvalidReq(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) => err);
};

function loadBankList() {
  return {
    type: LOADING_GET_BANKLIST,
  };
}

function bankListSuccess(data) {
  return {
    type: GET_BANKLIST_SUCCESS,
    payload: data,
  };
}

function bankListFailed(data) {
  return {
    type: GET_BANKLIST_FAILED,
    payload: data,
  };
}

function bankListInvalidReq(data) {
  return {
    type: GET_BANKLIST_INVALID_REQ,
    payload: data,
  };
}

function resetBankList() {
  return {
    type: RESET_GET_BANKLIST,
  };
}

const getBranchList = (userData) => async (dispatch) => {
  dispatch(loadBranchList());

  await account
    .post("getBranchList", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(branchListSuccess(res.data));
          break;

        case "2":
          dispatch(branchListFailed(res.data));
          break;

        case "3":
          dispatch(branchListInvalidReq(res.data));
          break;

        default:
          break;
      }
    })
    .catch((err) => err);
};

function loadBranchList() {
  return {
    type: LOADING_GET_BRANCHLIST,
  };
}

function branchListSuccess(data) {
  return {
    type: GET_BRANCHLIST_SUCCESS,
    payload: data,
  };
}

function branchListFailed(data) {
  return {
    type: GET_BRANCHLIST_FAILED,
    payload: data,
  };
}

function branchListInvalidReq(data) {
  return {
    type: GET_BRANCHLIST_INVALID_REQ,
    payload: data,
  };
}

function resetBranchList() {
  return {
    type: RESET_GET_BRANCHLIST,
  };
}

const getPostalCodes = (userData) => async (dispatch) => {
  dispatch(loadPostalCode());

  await account
    .post("getPostalCodes", userData)
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(postalCodeSuccess(res.data));
          break;

        case "2":
          dispatch(postalCodeFailed(res.data));
          break;

        case "3":
          dispatch(postalCodeInvalidReq(res.data));
          break;

        default:
          dispatch(postalCodeFailed(res.data));
          break;
      }
    })
    .catch((err) => err);
};

function loadPostalCode() {
  return {
    type: LOADING_GET_POSTALCODES,
  };
}

function postalCodeSuccess(data) {
  return {
    type: GET_POSTALCODES_SUCCESS,
    payload: data,
  };
}

function postalCodeFailed(data) {
  return {
    type: GET_POSTALCODES_FAILED,
    payload: data,
  };
}

function postalCodeInvalidReq(data) {
  return {
    type: GET_POSTALCODES_INVALID_REQ,
    payload: data,
  };
}

function resetPostalCodes() {
  return {
    type: RESET_GET_POSTALCODES,
  };
}

export {
  resetApp,
  resetSignup,
  resetInsertOTP,
  resetWalletSetting,
  logoutUser,
  insertOtp,
  signupUser,
  loginUser,
  getWalletSettings,
  resetLogin,
  getWalletRoles,
  resetWalletRoles,
  resetLogout,
  getDDT,
  gaddtResponse,
  resetDDT,
  getBankList,
  resetBankList,
  getBranchList,
  resetBranchList,
  getPostalCodes,
  resetPostalCodes,
  ddtFailed,
  ddtSuccess,
  ddtInvalidReq,
};
